import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useRumPageView = (_key: string, name: string, _context?: object) => {
  useEffect(() => {
    void datadogRum.startView(name);
  }, [name]);
};
